import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinvelhepune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Velhe Pune',
    heading: 'Sanavi Travels: Bus On Rent in Velhe Pune',
    headingDescription: 'Bus On Rent in Velhe Pune provides dependable and comfortable bus rental services for local trips, outstation travel, school picnics, weddings, corporate events, and religious tours. With a fleet of well-maintained AC and Non-AC buses ranging from 17, 20, 26, 32, 35, 40, to 50 seaters, along with experienced chauffeurs, we ensure safe and timely journeys for groups of all sizes. Offering flexible rental packages, transparent pricing, doorstep pickup, and 24/7 booking support, bus on rent in Velhe Pune is the ideal choice for stress-free group travel to Pune city, nearby tourist destinations, and long-distance routes.',

    top: 'Top Places to Visit in Velhe with Sanavi Travels',


"topPlaces": [
  {
    "title": "Velhe Town",
    "description": "Velhe is a scenic taluka in Pune district, nestled deep within the Sahyadri mountain ranges. Known for its untouched natural beauty, dense forests, and rich monsoon landscapes, Velhe is a paradise for nature lovers and trekkers. The region remains less commercialized, offering a peaceful environment and an authentic rural Maharashtrian experience."
  },
  {
    "title": "Torna Fort (Prachandagad)",
    "description": "Torna Fort, also known as Prachandagad, is the highest fort in Pune district and holds immense historical importance as the first fort captured by Chhatrapati Shivaji Maharaj. The fort features massive ramparts, temples, water tanks, and wide plateaus. Trekking to Torna is challenging yet rewarding, offering breathtaking views of the Sahyadri ranges and surrounding valleys."
  },
  {
    "title": "Rajgad Fort",
    "description": "Rajgad Fort, once the capital of the Maratha Empire, is one of the most significant forts near Velhe. The fort is famous for its majestic structures like Balekilla, Padmavati Machi, and Suvela Machi. It offers a powerful blend of history, architecture, and natural beauty, attracting trekkers, historians, and photography enthusiasts."
  },
  {
    "title": "Madhe Ghat",
    "description": "Madhe Ghat is a scenic mountain pass near Velhe, known for its lush greenery, deep valleys, and seasonal waterfalls. During the monsoon, the ghat transforms into a misty wonderland, making it a popular route for nature drives and photography."
  },
  {
    "title": "Velhe Forest Trails",
    "description": "The dense forests around Velhe are ideal for nature walks, birdwatching, and exploration. These trails pass through rich biodiversity zones, offering sightings of native flora and fauna, and providing a serene escape into nature."
  },
  {
    "title": "Temghar Dam (Nearby)",
    "description": "Located close to Velhe, Temghar Dam is a beautiful reservoir surrounded by hills and greenery. It is an ideal spot for scenic drives, sunset views, and quiet reflection, especially during the monsoon season."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "Velhe comes alive during the monsoon with numerous seasonal waterfalls cascading down cliffs and hillsides. These waterfalls enhance the region’s raw beauty and attract photographers and nature enthusiasts."
  },
  {
    "title": "Village Life and Rural Culture",
    "description": "The villages in Velhe taluka showcase traditional Maharashtrian rural life. Visitors can experience local farming practices, folk culture, simple cuisine, and warm hospitality, making it ideal for rural and eco-tourism."
  },
  {
    "title": "Trekking Base Villages",
    "description": "Velhe serves as a base region for several historic fort treks. Base villages provide food, guidance, and accommodation for trekkers heading to forts like Torna and Rajgad, adding to the region’s trekking ecosystem."
  },
  {
    "title": "Sunrise and Valley Viewpoints",
    "description": "High points around Velhe offer stunning sunrise views and sweeping panoramas of valleys and hills. These viewpoints are perfect for meditation, photography, and soaking in the untouched beauty of the Sahyadri ranges."
  }
]
,



"services": [
{
"name": "Bus On Rent in Velhe Pune",
"description": "Bus On Rent in Velhe Pune provides reliable and spacious buses for local and outstation travel. Perfect for families, groups, tourists, and corporate travelers, these buses ensure a smooth, safe, and comfortable journey. Professional drivers, flexible schedules, and well-maintained vehicles make it an ideal choice for weddings, sightseeing trips, corporate outings, and group excursions in and around Velhe and Pune."
},
{
"name": "Bus Hire Velhe",
"description": "Bus Hire Velhe offers convenient and customized bus rental services for corporate events, group trips, weddings, and long-distance travel. With modern buses, experienced drivers, and flexible itineraries, it provides a comfortable, safe, and stress-free travel experience for all passengers traveling to or from Velhe."
},
{
"name": "AC Bus Velhe",
"description": "AC Bus Velhe provides fully air-conditioned buses for a comfortable and refreshing journey. Ideal for long-distance trips, family outings, tourist excursions, and corporate travel, these buses offer smooth rides, professional drivers, and spacious interiors for a relaxing travel experience in and around Velhe."
},
{
"name": "Luxury Bus Velhe",
"description": "Luxury Bus Velhe offers premium buses with elegant seating, modern amenities, and spacious interiors for VIP travelers, corporate groups, and long-distance trips. Combining style, comfort, and safety, these buses are perfect for weddings, events, tourist trips, and corporate outings in Velhe and surrounding areas."
},
{
"name": "Tourist Bus Velhe",
"description": "Tourist Bus Velhe caters to travelers exploring Velhe and nearby scenic attractions. With organized itineraries, experienced drivers, and comfortable seating, it provides a hassle-free and enjoyable sightseeing experience, allowing tourists to explore cultural, historical, and natural locations without worrying about transportation."
},
{
"name": "Picnic Bus Velhe",
"description": "Picnic Bus Velhe provides dedicated buses for school trips, family outings, and group picnics. Spacious seating, reliable drivers, and flexible routes ensure a safe, convenient, and fun travel experience for passengers planning leisure trips to Velhe and nearby areas."
},
{
"name": "Corporate Bus Velhe",
"description": "Corporate Bus Velhe delivers professional and efficient transportation for business events, office trips, and employee commutes. With punctual service, modern buses, and courteous drivers, it ensures comfortable and safe travel for corporate teams traveling to Velhe and Pune."
},
{
"name": "Affordable Bus Velhe",
"description": "Affordable Bus Velhe offers budget-friendly bus rental services without compromising on comfort or safety. Ideal for students, families, corporate groups, and tourists, it combines cost-effective pricing with reliable service, spacious seating, and professional drivers for convenient travel to and from Velhe."
},
{
"name": "Chauffeur Driven Bus Velhe",
"description": "Chauffeur Driven Bus Velhe ensures a stress-free travel experience with professional drivers managing traffic, navigation, and schedules. Perfect for group travel, corporate trips, weddings, and tourist excursions, it guarantees smooth, safe, and comfortable journeys in Velhe and surrounding areas."
},
{
"name": "Best Bus Service Velhe",
"description": "Best Bus Service Velhe is known for punctuality, well-maintained vehicles, and exceptional customer service. Catering to families, tourists, corporate clients, and groups, it provides reliable, safe, and comfortable bus services for weddings, events, outings, and long-distance trips from Velhe."
},
{
"name": "Group Travel Bus Velhe",
"description": "Group Travel Bus Velhe specializes in transporting friends, families, corporate teams, and social groups efficiently and comfortably. With organized itineraries, spacious seating, and professional drivers, it ensures smooth, coordinated, and enjoyable travel experiences for all group trips in and around Velhe."
},
{
"name": "Online Bus Booking Velhe",
"description": "Online Bus Booking Velhe allows passengers to reserve buses quickly and conveniently with instant confirmation. Multiple bus options, flexible schedules, and transparent pricing make travel planning easy and hassle-free for families, tourists, and corporate travelers to or from Velhe."
},
{
"name": "Event Bus Velhe",
"description": "Event Bus Velhe provides dedicated buses for weddings, corporate events, parties, and other special occasions. With professional drivers, spacious vehicles, and reliable service, it ensures organized, safe, and comfortable transportation for all attendees in Velhe and surrounding areas."
},
{
"name": "Velhe Travel Bus",
"description": "Velhe Travel Bus offers comprehensive bus rental services for sightseeing trips, corporate travel, weddings, and outstation journeys. Combining safety, comfort, and professional service, it caters to families, tourists, and corporate clients seeking convenient and reliable transportation in Velhe and Pune."
},
{
"name": "Pune Velhe Bus",
"description": "Pune Velhe Bus provides well-maintained and comfortable buses for daily travel, weekend trips, and outstation journeys between Pune and Velhe. Ideal for families, tourists, and corporate travelers, it offers professional drivers, timely service, and a smooth travel experience, making commuting between Pune and Velhe convenient and enjoyable."
}
],
"tableData": [
["Bus On Rent in Velhe Pune", "Bus Hire Velhe"],
["AC Bus Velhe", "Luxury Bus Velhe"],
["Tourist Bus Velhe", "Picnic Bus Velhe"],
["Corporate Bus Velhe", "Affordable Bus Velhe"],
["Chauffeur Driven Bus Velhe", "Best Bus Service Velhe"],
["Group Travel Bus Velhe", "Online Bus Booking Velhe"],
["Event Bus Velhe", "Velhe Travel Bus"],
["Pune Velhe Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Velhe Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Velhe Pune, perfect for group outings, school trips, family tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Velhe Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Velhe Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Velhe Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Velhe Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Velhe Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Velhe Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Velhe Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Velhe Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Velhe Pune?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Velhe Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Velhe Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Velhe Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Velhe Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Velhe Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Velhe Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Velhe Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akshay More',
    feedback: 'We rented a bus in Velhe Pune from Sanavi Travels — comfortable journey and fantastic service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shruti Patil',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our trip in Velhe Pune. Highly recommended!',
    rating: 5
  }
];
























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusOrCoach",
  "name": "Bus On Rent in Velhe Pune - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, and affordable buses for hire in Velhe Pune. Perfect for tourist trips, corporate travel, picnics, group travel, and events. Chauffeur-driven service with online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "27"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Velhe Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC, luxury, and affordable buses in Velhe Pune with Sanavi Travels. Ideal for tourist trips, picnics, corporate travel, group trips, and events. Chauffeur-driven buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/145.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinvelhepune;